import { options } from '@engine/features/apply_chosen';

function reInitDatepicker() {
  var datetimepickers = $('.business-attributes-container input.datepicker');
  datetimepickers.datetimepicker({
    format: 'DD-MM-YYYY',
    sideBySide: true,
    locale: moment.locale(I18n.locale)
  });
}

function renderBusinessAttributeFields(terminalId, trxType) {
  var vtFeature = trxType === 'pay_by_link' ? 'pay_by_link' : 'virtual-terminal';
  $.ajax({
    method: 'GET',
    url: "/".concat(vtFeature, "/business_attributes"),
    dataType: 'html',
    data: {
      terminal_id: terminalId,
      transaction_type: trxType
    }
  }).done(function (response) {
    var container = $('.business-attributes-container');
    container.html($.parseHTML(response));
    $('.for_chosen', container).chosen(options);
    reInitDatepicker();
  });
}

var BusinessAttributes = {
  reInitDatepicker: reInitDatepicker,
  renderBusinessAttributeFields: renderBusinessAttributeFields
};
export default BusinessAttributes;